<template>
  <div v-if="!isSelectedOptionEmpty" class="product-price">
    <!-- Customer discount (e.g., VIP discount) -->
    <div v-if="customerDiscountVal > 0 && discountPrice !== actualPrice" class="product-price__old">
      {{ actualPrice }}
    </div>

    <!-- Regular sale (no customer-specific discount) -->
    <div v-if="customerDiscountVal === 0 && discountPrice !== actualPrice" class="product-price__old">
      {{ compareAtPrice }}
    </div>

    <!-- Final price -->
    <div class="product-price__new">
      {{ discountPrice }}
    </div>

    <!-- Show "You save" after price -->
    <div v-if="discountPrice !== actualPrice" class="product-price__save-text">
      {{ customerDiscountVal > 0 ? youSave(actualPrice, discountPrice) : youSave(compareAtPrice, discountPrice) }}
    </div>
  </div>
</template>

<script setup>
  import { computed, toRefs, ref, onBeforeMount } from 'vue';

  const props = defineProps({
    product: {
      type: Object,
      default: () => ({}),
    },
    selectedFirstOption: {
      type: Object,
      default: () => ({}),
    },
  });

  const { product, selectedFirstOption } = toRefs(props);
  const customerDiscountVal = ref(0);

  onBeforeMount(() => {
    getCustomerDiscount();
  });

  const discountPrice = computed(() => window.formattedPrice(discountPriceLogic(selectedFirstOption.value)));
  const isSelectedOptionEmpty = computed(() => Object.keys(selectedFirstOption.value).length === 0);
  const compareAtPrice = computed(() => window.formattedPrice(selectedFirstOption.value.compare_at_price));
  const actualPrice = computed(() => {
    if (selectedFirstOption.value.compare_at_price > 0) {
      return window.formattedPrice(selectedFirstOption.value.compare_at_price);
    } else {
      return window.formattedPrice(selectedFirstOption.value.price);
    }
  });

  const youSave = (price, secondPrice) => {
    let finalPrice = parseFloat(price.replace('$', '')) - parseFloat(secondPrice.replace('$', ''));
    return finalPrice % 1 != 0 ? 'You save $' + finalPrice.toFixed(2) : 'You save $' + finalPrice;
  };

  const getCustomerDiscount = () => {
    customerDiscountVal.value = window.customerDiscount(product.value.tags);
  };

  const discountPriceLogic = (data) => {
    if (data.compare_at_price > 0) {
      if (data.compare_at_price * (1 - customerDiscountVal.value) < data.price) {
        return data.compare_at_price * (1 - customerDiscountVal.value);
      } else {
        return data.price;
      }
    } else {
      return data.price * (1 - customerDiscountVal.value);
    }
  };
</script>
